import last from "lodash/last";
import pull from "lodash/pull";
import find from "lodash/find";
import get from "lodash/get";
import {
  ADD_FIELD,
  REMOVE_FIELD,
  UPDATE_FIELD,
  UPDATE_LAYER,
  UPDATE_GLOBAL_PARAMETER,
  RECEIVE_ARTUS_CONFIGURATION,
  SET_HIDE_TOP_VIEW,
} from "./Actions";
import filter from "lodash/filter";
import isEmpty from "lodash/isEmpty";

const initialState = {
  floor: "frontend_noBottom",
  doubleShelf: false,
  distance: 200,
  highestFrame: 2500,
  overallWidth: 5655,
  scaleFactor: 0,
  hideTopView: true,
  fields: [
    {
      id: 1,
      height: "frontend_heightARTUS2500",
      width: "frontend_width2700",
      supportBars: "frontend_layers3",
      shelfLoad: "frontend_shelfLoad2000",
      shelfBottom: "frontend_noBottom",
      securing: "frontend_noSecuring",
      leftBullBar: "no_bullbar",
      rightBullBar: "no_bullbar",
      isLeftOuterField: true,
      isRightOuterField: false,
      palletWeight: 665,
      weightExceedsMaxFieldLoad: false,
      weightExcessPopupShown: false,
      layers: [
        { id: 1, floor: "frontend_noBottom" },
        { id: 2, floor: "frontend_noBottom" },
        { id: 3, floor: "frontend_noBottom" },
      ],
    },
    {
      id: 2,
      height: "frontend_heightARTUS2500",
      width: "frontend_width2700",
      supportBars: "frontend_layers3",
      shelfLoad: "frontend_shelfLoad2000",
      shelfBottom: "frontend_noBottom",
      securing: "frontend_noSecuring",
      leftBullBar: "no_bullbar",
      rightBullBar: "no_bullbar",
      isLeftOuterField: false,
      isRightOuterField: true,
      palletWeight: 665,
      weightExceedsMaxFieldLoad: false,
      weightExcessPopupShown: false,
      layers: [
        { id: 1, floor: "frontend_noBottom" },
        { id: 2, floor: "frontend_noBottom" },
        { id: 3, floor: "frontend_noBottom" },
      ],
    },
  ],
  shelfLoadRules: [
    {
      height: 5500,
      width: 1900,
      maxShelfLoad: 3000,
      layers: 4,
      palletWeight: 1300,
    },
    {
      height: 7000,
      width: 1900,
      maxShelfLoad: 3000,
      layers: 6,
      palletWeight: 1350,
    },
    {
      height: 7500,
      width: 1900,
      maxShelfLoad: 3000,
      layers: 6,
      palletWeight: 1350,
    },
    {
      height: 4000,
      width: 2700,
      maxShelfLoad: 3000,
      layers: 4,
      palletWeight: 900,
    },
    {
      height: 4500,
      width: 2700,
      maxShelfLoad: 3000,
      layers: 4,
      palletWeight: 900,
    },
    {
      height: 5500,
      width: 2700,
      maxShelfLoad: 3000,
      layers: 4,
      palletWeight: 825,
    },
    {
      height: 7000,
      width: 2700,
      maxShelfLoad: 3000,
      layers: 6,
      palletWeight: 870,
    },
    {
      height: 7500,
      width: 2700,
      maxShelfLoad: 3000,
      layers: 6,
      palletWeight: 870,
    },
    {
      height: 3000,
      width: 3600,
      maxShelfLoad: 4000,
      layers: 3,
      palletWeight: 800,
    },
    {
      height: 3500,
      width: 3600,
      maxShelfLoad: 4000,
      layers: 3,
      palletWeight: 800,
    },
    {
      height: 4000,
      width: 3600,
      maxShelfLoad: 4000,
      layers: 3,
      palletWeight: 800,
    },
    {
      height: 4000,
      width: 3600,
      maxShelfLoad: 4000,
      layers: 4,
      palletWeight: 700,
    },
    {
      height: 4500,
      width: 3600,
      maxShelfLoad: 4000,
      layers: 3,
      palletWeight: 800,
    },
    {
      height: 4500,
      width: 3600,
      maxShelfLoad: 4000,
      layers: 4,
      palletWeight: 700,
    },
    {
      height: 5500,
      width: 3600,
      maxShelfLoad: 4000,
      layers: 2,
      palletWeight: 975,
    },
    {
      height: 5500,
      width: 3600,
      maxShelfLoad: 4000,
      layers: 3,
      palletWeight: 775,
    },
    {
      height: 5500,
      width: 3600,
      maxShelfLoad: 4000,
      layers: 4,
      palletWeight: 635,
    },
    {
      height: 6000,
      width: 3600,
      maxShelfLoad: 4000,
      layers: 4,
      palletWeight: 975,
    },
    {
      height: 6000,
      width: 3600,
      maxShelfLoad: 4000,
      layers: 5,
      palletWeight: 850,
    },
    {
      height: 6500,
      width: 3600,
      maxShelfLoad: 4000,
      layers: 4,
      palletWeight: 975,
    },
    {
      height: 6500,
      width: 3600,
      maxShelfLoad: 4000,
      layers: 5,
      palletWeight: 850,
    },
    {
      height: 7000,
      width: 3600,
      maxShelfLoad: 4000,
      layers: 4,
      palletWeight: 950,
    },
    {
      height: 7000,
      width: 3600,
      maxShelfLoad: 4000,
      layers: 5,
      palletWeight: 780,
    },
    {
      height: 7000,
      width: 3600,
      maxShelfLoad: 4000,
      layers: 6,
      palletWeight: 670,
    },
    {
      height: 7500,
      width: 3600,
      maxShelfLoad: 4000,
      layers: 3,
      palletWeight: 950,
    },
    {
      height: 7500,
      width: 3600,
      maxShelfLoad: 4000,
      layers: 4,
      palletWeight: 885,
    },
    {
      height: 7500,
      width: 3600,
      maxShelfLoad: 4000,
      layers: 5,
      palletWeight: 780,
    },
    {
      height: 7500,
      width: 3600,
      maxShelfLoad: 4000,
      layers: 6,
      palletWeight: 665,
    },
  ],
};

export default function ArtusReducer(state = initialState, action = {}) {
  switch (action.type) {
    case ADD_FIELD: {
      const fields = state.fields;
      // the new field is always a copy of the last field
      const lastField = last(fields);
      lastField.isRightOuterField = false;
      const newField = {
        ...lastField,
        id: lastField.id + 1,
        layers: lastField.layers.map((a) => ({ ...a })),
        isLeftOuterField: false,
        isRightOuterField: true,
      };
      if (lastField.rightBullBar !== "no_bullbar") {
        newField.rightBullBar = lastField.rightBullBar;
        lastField.rightBullBar = "no_bullbar";
        if (lastField.leftBullBar !== "no_bullbar") {
          lastField.rightBullBar = lastField.leftBullBar;
        }
      } else if (lastField.rightBullBar === "no_bullbar" && lastField.leftBullBar !== "no_bullbar") {
        lastField.rightBullBar = lastField.leftBullBar;
      }
      fields.push(newField);
      return {
        ...state,
        fields,
      };
    }

    case REMOVE_FIELD: {
      const { fieldId } = action;
      const fields = state.fields;
      let highestFrame = state.highestFrame;
      const fieldToRemove = find(fields, { id: fieldId });
      const fieldToRemoveHeight = parseInt(fieldToRemove.height.substring(20), 10);
      const newFields = pull(fields, fieldToRemove);
      const newFieldsLength = newFields.length;
      newFields.map((field) => {
        if (field.id > fieldId) {
          field.id -= 1;
        }
        if (field.id === newFieldsLength) {
          field.isRightOuterField = true;
          field.rightBullBar = get(fieldToRemove, "rightBullBar");
        }
      });
      if (fieldToRemoveHeight === highestFrame) {
        // set lowest possible value
        highestFrame = 2500;
        newFields.map((field) => {
          const fieldHeight = parseInt(field.height.substring(20), 10);
          if (fieldHeight > highestFrame) {
            highestFrame = fieldHeight;
          }
        });
      }

      return {
        ...state,
        fields: newFields,
        highestFrame: highestFrame,
      };
    }

    case UPDATE_FIELD: {
      const { artusIdentifierAttributeValueMap, fieldId, key, value } = action;
      let highestFrame = state.highestFrame;
      const newFields = state.fields;
      const oldHeightOfCurrentField = find(newFields, { id: fieldId })["height"];
      const field = find(newFields, { id: fieldId });
      field[key] = value;
      if (key === "supportBars") {
        const layers = find(newFields, { id: fieldId }).layers;
        const layersValue = Number(value.match(/\d+/));
        if (layers.length > layersValue) {
          find(newFields, { id: fieldId }).layers = layers.slice(0, layersValue);
        } else {
          const newLayers = layers;
          for (let l = layers.length; l < layersValue; l++) {
            newLayers.push({ id: l + 1, floor: state.floor });
          }
          find(newFields, { id: fieldId }).layers = newLayers;
        }
      }
      if (key === "width") {
        let shelfLoad = 3850;
        switch (Number(value.match(/\d+/))) {
          case 1900:
            {
              shelfLoad = "frontend_shelfLoad3850";
            }
            break;
          case 2700:
            {
              const currentShelfLoad = find(newFields, { id: fieldId })["shelfLoad"].value;
              shelfLoad =
                currentShelfLoad === "frontend_shelfLoad3070"
                  ? "frontend_shelfLoad3070"
                  : "frontend_shelfLoad2000";
            }
            break;
          case 3600:
            {
              shelfLoad = "frontend_shelfLoad4200";
            }
            break;
          default:
            shelfLoad = "frontend_shelfLoad3850";
        }
        find(newFields, { id: fieldId })["shelfLoad"] = shelfLoad;
      }
      if (key === "shelfLoad") {
        let width = "frontend_width1900";
        switch (Number(value.match(/\d+/))) {
          case 3850:
            {
              width = "frontend_width1900";
            }
            break;
          case 2000:
            {
              width = "frontend_width2700";
            }
            break;
          case 3070:
            {
              width = "frontend_width2700";
            }
            break;
          case 4500:
            {
              width = "frontend_width3600";
            }
            break;
          default:
            width = "frontend_width1900";
            find(newFields, { id: fieldId })["width"] = width;
        }
      }
      if (key === "leftBullBar" && newFields.length >= fieldId && fieldId !== 1) {
        find(newFields, { id: fieldId - 1 })["rightBullBar"] = value;
      }
      if (key === "rightBullBar" && newFields.length !== fieldId) {
        find(newFields, { id: fieldId + 1 })["leftBullBar"] = value;
      }
      if (key === "height") {
        const oldHeightOfCurrentFieldInt = parseInt(oldHeightOfCurrentField.substring(20), 10);
        const height = parseInt(value.substring(20), 10);
        if (height > highestFrame) {
          highestFrame = height;
        } else if (height < highestFrame && oldHeightOfCurrentFieldInt === highestFrame) {
          // find new highestFrame by iterating over all fields
          highestFrame = height;
          newFields.map((field) => {
            const fieldHeight = parseInt(field.height.substring(20), 10);
            if (fieldHeight > highestFrame) {
              highestFrame = fieldHeight;
            }
          });
        }
      }

      if (key === "width" || key === "height" || key === "shelfLoad" || key === "supportBars") {
        const selectedOptions = {
          height: Number(artusIdentifierAttributeValueMap.get(field.height)),
          width: Number(artusIdentifierAttributeValueMap.get(field.width)),
          layers: field.layers.length,
          maxShelfLoad: Number(artusIdentifierAttributeValueMap.get(field.shelfLoad)),
        };

        const matchingRule = filter(state.shelfLoadRules, {
          height: selectedOptions.height,
          width: selectedOptions.width,
          layers: selectedOptions.layers,
          maxShelfLoad: selectedOptions.maxShelfLoad,
        });

        const hasMatchedRule = !isEmpty(matchingRule);

        if (field.weightExcessPopupShown) {
          field.weightExcessPopupShown = false;
        }

        if (hasMatchedRule) {
          field.weightExceedsMaxFieldLoad = true;
          field.palletWeight = matchingRule[0].palletWeight;
        } else {
          field.weightExceedsMaxFieldLoad = false;
          field.palletWeight = null;
        }
      }
      return {
        ...state,
        highestFrame: highestFrame,
        fields: newFields,
      };
    }

    case UPDATE_LAYER: {
      const { fieldId, layerId, key, value } = action;
      const newFields = state.fields;
      const field = find(newFields, { id: fieldId });
      find(field.layers, { id: layerId })[key] = value;
      return {
        ...state,
        fields: newFields,
      };
    }

    case UPDATE_GLOBAL_PARAMETER: {
      const { key, value } = action;
      const newFields = state.fields;
      if (key === "floor") {
        newFields.forEach((field) => {
          field.layers.forEach((layer) => (layer.floor = value));
        });
      }
      return {
        ...state,
        doubleShelf: key === "doubleShelf" ? value : state.doubleShelf,
        floor: key === "floor" ? value : state.floor,
        distance: key === "distance" ? value : state.distance,
        overallWidth: key === "overallWidth" ? value : state.overallWidth,
        scaleFactor: key === "scaleFactor" ? value : state.scaleFactor,
        fields: newFields,
      };
    }

    case RECEIVE_ARTUS_CONFIGURATION: {
      const { data } = action;
      const newState = data;
      return newState;
    }

    case SET_HIDE_TOP_VIEW: {
      const { hide } = action;
      return {
        ...state,
        hideTopView: hide,
      };
    }

    default:
      return state;
  }
}
